import { field, relation, json,text } from '@nozbe/watermelondb/decorators';
import { SURVEY_RESPONSES_SCHEMA } from '../schema';
import { sanitizeOptions } from '../../constants';
import { Model } from '@nozbe/watermelondb';

export default class FeedbackResponses extends Model {
    static table = SURVEY_RESPONSES_SCHEMA

    static associations = {
        business: { type: 'belongs_to', key: 'business_id' },
    }

    @text('secondary_answer') secondary_answer;
    @text('question') question;
    @text('answer') answer;
    @text('type') type;

    @json('options', sanitizeOptions) options;

    @relation('business', 'business_id') business;
};